import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { constants } from '../../constants';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MetadataContentTabs } from '../../ui-parts/MetadataContentTabs';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';

/**MyMine Version3.0 Marketing画面新規追加
 * Marketing Page Component
 */

const Marketing = () => {

  const screenId = 'MyM324';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(null);
  const navigate = useNavigate();
  const queryParam = useParams();
  const isPc = useMediaQuery(mediaQuery.pc);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewFileId, setPreviewFileId] = useState(false);
  const handleModalClose = () => setIsModalOpen(false);
  const location = useLocation();
  const videoRef = useRef(null);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {

    /**
     * Contents情報取得成功時処理
     * @param {any} result
     */
    const callbackSuccessRequestMarketingContents = (result) => {

      if (result === null) {
        // 取得情報がない場合、失敗処理を行う
        callbackFailedRequestMarketingContents();
        return;
      }
      setContent(result);
      setIsLoading(false);

      if (location.state?.previewFileId) {
        setTimeout(() => {
          scrollToSection('fileArea-scroll')
          setPreviewFileId(location.state.previewFileId);
          setIsModalOpen(true);
         },300)
      }
    }

    /**
     * Contents情報取得失敗時処理
     */
    const callbackFailedRequestMarketingContents = () => {
      setIsLoading(false);
      // エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }

    // 表示情報取得
    apiRequest.requestJson(`api/marketing/load`, 'GET', callbackSuccessRequestMarketingContents, callbackFailedRequestMarketingContents);

  }, []);

  if (content == null)
    return <MyMProgress />

  // パラメータのメタデータ
  const isBusinessAreaMetadata = content.MetadataCategoryId != null;

  return (
    <Box className='py-1 d-flex flex-column'>
      {isLoading && <MyMProgress />}
      <Box className='mb-4'>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblMarketingTitle}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblMarketingDescription}</MyMLabel>
      </Box>
      <Grid container>
        <Grid item xs={isPc ? 1.5 : 12} />
        <Grid item xs={isPc ? 9 : 12}>
          <Box className='mb-4'>
            <Grid container>
              <Grid item xs={isPc ? 7 : 12}>
                {/*Video*/}
                <video
                  controls
                  autoPlay
                  muted
                  playsInline
                  controlsList="nodownload"
                  disablePictureInPicture
                  disableRemotePlayback
                  width='90%'
                  ref={videoRef}>
                  <source src={`api/page/file?fileName=${content.Item2.Value}`} type="video/mp4" />
                  <p>Your browser doesn't support HTML5 video.</p>
                </video>
              </Grid>
              <Grid item xs={isPc ? 5 : 12}>
                {/*Description*/}
                <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblVideoMessageTitle}</MyMVariantLabel>
                <MyMVariantLabel variant='h6'>{controlSettings.LabelList.lblVideoSummaryTitle}</MyMVariantLabel>
                <MyMVariantLabel variant='h8'>{controlSettings.LabelList.lblVideoSummaryDescription}</MyMVariantLabel>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={isPc ? 1.5 : 12} />
      </Grid>
      <br />
      {isPc ?
        <Grid container>
          <Grid item xs={1.5} />
          <Grid item xs={9}>
            <Grid container className='pb-2 flex-grow-1'>
              <Grid item xs={12}>
                <MyMVariantLabel variant='h3' style={{ fontWeight: 'bold' }}>
                  {controlSettings.LabelList.lblMarketingReportsTitle}
                </MyMVariantLabel>
                <Box sx={{ height: { xs: '15px'} }} />
              </Grid>
              <Grid item xs={12} id='fileArea-scroll'>
                <MetadataContentTabs
                  paramMetadataId={queryParam.metadata_id}
                  screenId={screenId}
                  metadataContent={content.Item1.Value}
                  setIsLoading={setIsLoading}
                  canShareContents={true}
                  contentsShareParameter={location.state}
                  isDefaultOpenFirstAccordion={!isBusinessAreaMetadata}
                  
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1.5} />
        </Grid>
        :
        <Grid container className='pb-2 flex-grow-1'>
          <Grid item xs={12} >
            <MyMVariantLabel variant='h5' style={{ fontWeight: 'bold' }}>
              {controlSettings.LabelList.lblMarketingReportsTitle}
            </MyMVariantLabel>

          </Grid>
          <Grid item xs={12} md={8.7}>
            <MetadataContentTabs
              paramMetadataId={queryParam.metadata_id}
              screenId={screenId}
              metadataContent={content.Item1.Value}
              setIsLoading={setIsLoading}
              canShareContents={true}
              contentsShareParameter={location.state}
              isDefaultOpenFirstAccordion={!isBusinessAreaMetadata}
            />
          </Grid>
        </Grid>
      }
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={previewFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>
    </Box>

  );
}
export default Marketing;
